import FileDownloadRoundedIcon from "@mui/icons-material/FileDownloadRounded"
import { ListItemIcon, ListItemText, MenuItem } from "@mui/material"

import { fileDownload } from "../../../helpers/file.helpers"
import useHTMLFileContent from "../../../hooks/useHTMLFileContent"

import InfoOutlineIcon from "@mui/icons-material/InfoOutlined"
import saveAs from "file-saver"
import { t } from "i18next"
import { useState } from "react"
import { useAppDispatch } from "../../../hooks/useRedux"
import { useToast } from "../../../hooks/useToast"
import { useVerifyPermission } from "../../../hooks/useVerifyPermission"
import { GraphicT } from "../../../store/slices/graphic.slice"
import { setLoading } from "../../../store/slices/loading.slice"
import AlertDialog from "../../common/AlertDialog"
import InfoTooltip from "../../common/InfoTooltip"

interface Props {
    label: string
    graphic: GraphicT
    onClick: () => void
    disabled: boolean
    pack?: boolean
    infoText?: string
}

const DownloadFile = ({ label, graphic, onClick, disabled, pack, infoText }: Props) => {
    const dispatch = useAppDispatch()
    const [openALert, setOpenAlert] = useState<boolean>(false)

    const { success } = useToast()
    const { processFile, processZip } = useHTMLFileContent()
    const { isFreeLicense } = useVerifyPermission(graphic, graphic.company)

    // Process and download HTML + JSON file
    const handleHTMLfileDownload = async () => {
        if (pack) {
            dispatch(setLoading(true))
            saveAs(await processZip(), `${graphic.name}.zip`)
            dispatch(setLoading(false))
        } else {
            if (isFreeLicense) {
                setOpenAlert(true)
                return
            } else {
                fileDownload(`${graphic.name}.html`, processFile())
            }
        }

        onClick()
        success("graphics:successMessage.graphicExported")
    }

    return (
        <>
            <MenuItem key="download" onClick={handleHTMLfileDownload} disabled={disabled}>
                <ListItemIcon>
                    <FileDownloadRoundedIcon />
                </ListItemIcon>
                <ListItemText>
                    {label}
                    {infoText ? (
                        <InfoTooltip
                            text={infoText}
                            icon={<InfoOutlineIcon sx={{ opacity: 0.6 }} />}
                        />
                    ) : null}
                </ListItemText>
            </MenuItem>
            <AlertDialog
                open={openALert}
                title={t("editor:exportAlertDialog.title")}
                content={t("editor:exportAlertDialog.text")}
                onDisagree={() => {
                    setOpenAlert(false)
                }}
                onAgree={() => {
                    fileDownload(
                        `${graphic.name}.html`,
                        processFile(undefined, undefined, isFreeLicense)
                    ) //here i want pase pureHtml prop
                    setOpenAlert(false)
                    onClick()
                }}
                txtDisagree={t("disagree")}
                txtAgree={t("exportAnyway")}
            ></AlertDialog>
        </>
    )
}

export default DownloadFile
